import { useScan } from './ScanLayout';
import { PageHeader, Section, Banner, KV, Stat, StatGrid } from '../components/Section';

export function SslPage() {
  const scan = useScan();
  const m = scan.modules.ssl;
  if (!m) return (
    <>
      <PageHeader title="SSL / TLS" subtitle="Module result not available." />
      <Section accent="amber"><Banner tone="warn" title="SSL analyzer didn't return a result" /></Section>
    </>
  );

  const expTone =
    m.days_to_expiry === undefined ? 'mute' :
    m.days_to_expiry < 7  ? 'bad'  :
    m.days_to_expiry < 21 ? 'warn' :
                            'ok';

  return (
    <>
      <PageHeader
        title="SSL / TLS Analysis"
        subtitle="Certificate chain, expiry, and issuer trust — sourced from public Certificate Transparency logs"
      />

      <Section title="Certificate Overview" accent={m.reachable ? 'green' : 'rose'}>
        <StatGrid cols={3}>
          <Stat label="Reachable" value={m.reachable ? 'YES' : 'NO'}
                tone={m.reachable ? 'ok' : 'bad'} />
          <Stat label="Valid Certs" value={m.cert_count} tone="info" sub="Currently valid, covering this domain" />
          <Stat label="Days to Expiry" value={m.days_to_expiry ?? '—'} tone={expTone}
                sub={m.days_to_expiry === undefined ? '—'
                   : m.days_to_expiry < 7  ? 'Renew now'
                   : m.days_to_expiry < 21 ? 'Renew soon'
                   : m.days_to_expiry < 60 ? 'OK'
                                           : 'Comfortable'} />
        </StatGrid>
      </Section>

      {m.recent_cert ? (
        <Section title="Most Recent Certificate" accent="green"
          status={{ label: 'ACTIVE', tone: 'ok' }}>
          <div className="grid gap-4 md:grid-cols-2">
            <KV k="Common Name" v={m.recent_cert.common_name} />
            <KV k="Issuer" v={m.recent_cert.issuer_name} />
            <KV k="Not Before" v={fmt(m.recent_cert.not_before)} />
            <KV k="Not After" v={fmt(m.recent_cert.not_after)} />
            <KV k="Serial" v={
              <span className="font-mono text-xs break-all">{m.recent_cert.serial_number}</span>
            } />
          </div>
        </Section>
      ) : (
        <Section title="No active certificate found" accent="rose">
          <Banner tone="bad" title="We couldn't find a current certificate in CT logs">
            Either the domain doesn't terminate TLS publicly, or CT propagation is
            still pending (very fresh certs may take minutes to appear).
          </Banner>
        </Section>
      )}
    </>
  );
}

function fmt(d: string): string {
  try { return new Date(d).toUTCString().replace(' GMT', ' UTC'); }
  catch { return d; }
}
